import { api } from "@/config/api-fetch";
import { localDate, localHour, localMinute, localWeekday } from "@/utils/date";
import { useQuery } from "@tanstack/react-query";

export type AutoPosting = {
    post_id: number;
    is_active: boolean;
    is_running: boolean;

    topics: string[];
    tone: string;
    language: string;
    min_length: string;
    max_length: string;
    slug_language: string;
    slug_max_length: string;
    type: string;
    status: "draft" | "published" | "private";
    weekdays: number[];
    times: { hour: number; minute: number }[];
    exp_date: Date;

    author: {
        id: number;
        username: string;
        display_name: string;
        email: string;
        url: string;
    };
    posts: {
        id: number;
        run_date?: number | string;
        title: string;
        content: string;
        status: string;
        type: string;
        created_at: number | string;
        view_link: string;
        edit_link: string;
        // Auto-post specific fields
        auto_post_status?: "pending" | "completed" | "failed";
        auto_post_topic?: string;
        auto_post_error?: string;
    }[];
    attachments: {
        id: number;
        title: string;
        url: string;
    }[];
};

export function useAutoPostings() {
    const query = useQuery({
        queryKey: ["auto-posting"],
        queryFn: async () =>
            api.get<AutoPosting[]>(`/auto-posting?populate=author,posts,attachments`).then((postings) => {
                postings.forEach((posting) => {
                    /**
                     * TIMEZONE CONVERSION: UTC → Local
                     *
                     * The backend stores all schedule data in UTC.
                     * We convert it to local timezone here so all components
                     * can display and work with local times directly.
                     *
                     * DO NOT convert again in display components!
                     */
                    posting.weekdays = posting.weekdays.map((day) => localWeekday(day));
                    posting.times = posting.times.map((t) => ({ hour: localHour(t.hour), minute: localMinute(t.minute) }));
                    posting.exp_date = localDate(new Date(Number(posting.exp_date) * 1000));
                });

                return postings;
            }),
    });

    return query;
}
